import { useEffect, useRef } from 'react';

function useHandlers(callbacks) {
  const { onDomainSearchFailure, onSearchPerformed, onSearchStart, onSelect } = callbacks;

  const callbacksRef = useRef({
    onDomainSearchFailure,
    onSearchPerformed,
    onSearchStart,
    onSelect,
  });

  useEffect(() => {
    callbacksRef.current = {
      onDomainSearchFailure,
      onSearchPerformed,
      onSearchStart,
      onSelect,
    };
  }, [onDomainSearchFailure, onSearchPerformed, onSearchStart, onSelect]);

  return callbacksRef;
}

export default useHandlers;
